/* VUE */
import Vue from 'vue';
import App from '@/App.vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';

/* VUE Router */
import router from '@/router';

// Highcharts
import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
import Pie from "highcharts/modules/variable-pie";
import HighchartsVue from "highcharts-vue";
import boost from "highcharts/modules/boost";
import exportingInit from 'highcharts/modules/exporting';
import NoDataModule from "highcharts/modules/no-data-to-display.js";

/* Bootstrap + icons (Remove Icons if not used at all) */
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueDOMPurifyHTML)

Stock(Highcharts);
Pie(Highcharts);
exportingInit(Highcharts);
NoDataModule(Highcharts);
Vue.use(HighchartsVue);
boost(Highcharts);

/* CSS */
// Needed for Bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

/* SCSS */
import '@/assets/scss/app.scss';

/* Config */
Vue.config.productionTip = false;

/* Vue binds */
Vue.prototype.$moment = require('moment-timezone');

/* Init vue */
new Vue({
    render: h => h(App),
    router,
}).$mount('#app');

/* Directives */

// Fade elements in
Vue.directive('vpshow', {
    inViewport (el) {
        const rect = el.getBoundingClientRect()
        return !(rect.bottom < 0 || rect.right < 0 ||
            rect.left > window.innerWidth ||
            rect.top > window.innerHeight)
    },

    bind(el, binding) {
        el.classList.add('before-enter')
        el.$onScroll = function() {
            if (binding.def.inViewport(el)) {
                el.classList.add('enter')
                el.classList.remove('before-enter')
                binding.def.unbind(el, binding)
            }
        }
        document.addEventListener('scroll', el.$onScroll)
    },

    inserted(el) {
        el.$onScroll()
    },

    unbind(el) {
        document.removeEventListener('scroll', el.$onScroll)
        delete el.$onScroll
    }
})